import styled from "styled-components";
import { Link } from "react-router-dom";
import { mainColor, mainFont } from "../../styles/global";

export const SchorlarshipWrapper = styled.div`
  > p {
    font-family: "Avenir";
    font-style: normal;
    font-weight: 400;
    font-size: 26px;
    line-height: 31px;
    letter-spacing: 0.01em;
    text-transform: uppercase;
    color: ${mainColor};
    text-align: center;
    margin-bottom: 2rem;
    @media screen and (max-width: 768px) {
      font-family: "Avenir";
      font-size: 12px;
      line-height: 0px;
    }
  }

  align-items: center;
  padding: 7% 7%;
  h1 {
    font-family: ${mainFont};
    color: ${mainColor};
    font-style: normal;
    font-weight: 750;
    font-size: 56px;
    line-height: 68px;
    text-align: center;
    letter-spacing: 0.01em;
    margin-bottom: 8rem;
    div {
      align-items: center;
      justify-cotnent: center;
      text-align: center;
    }
    span {
      color: #008080;
    }

    @media screen and (max-width: 768px) {
      font-style: normal;
      font-weight: 750;
      font-size: 16px;
      letter-spacing: 0.01em;
      margin-top: -20px;
      margin-bottom: 1rem;
    }
  }
`;

export const SchorlarshipCard = styled.div`
  width: 100%;
  padding: 8%;
  // height: 512px;
  gap: 3rem;
  background: linear-gradient(102.52deg, #008080 0.37%, #090458 86.07%);
  border-radius: 24px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  @media screen and (max-width: 768px) {
    padding: 8% 5%;
    gap: 1rem;
    height: 185px;
    left: 29px;
    top: 8505.97px;
    background: linear-gradient(102.52deg, #008080 0.37%, #090458 86.07%);
    border-radius: 9px;
  }
  p {
    font-family: ${mainFont};
    font-style: normal;
    font-weight: 800;
    font-size: 32px;
    line-height: 42px;
    text-align: center;
    letter-spacing: 0.01em;
    color: #ffffff;
    span {
      color: #ff887c;
    }
    @media screen and (max-width: 768px) {
      font-size: 12px;
      line-height: 16px;
      font-weight: 600;
    }
  }
`;
export const NavLink = styled(Link)`
  font-family: ${mainFont};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.01em;
  color: #ffffff;
  text-decoration: none;
  padding: 10px 20px;
  border: 2.5px solid #ffffff;
  border-radius: 9px;
  @media screen and (max-width: 768px) {
    font-weight: 500;
    font-size: 12px;
    line-height: 11px;
    letter-spacing: 0.01em;
    border: 1.5px solid #ffffff;
  }
`;
